module.exports = __webpack_public_path__ + "static/media/doubleticks.03c074e6.svg";